/* eslint-disable react/prop-types */
import React, { Fragment } from 'react';
import get from 'lodash/get';
import clsx from 'clsx';
import { Box } from '@material-ui/core';
import Modal from 'components/Modal';
import ProductLinkageItem from '../ProductLinkageItem';

import classes from './ProductLinkageModal.module.scss';

const ProductLinkageModal = ({ data = [], open, handleClose }) => {
  return (
    <Modal
      modalProps={{
        className: {
          classRoot: clsx(classes.root),
          classTitle: classes.titleModal,
        },
        open,
        handleClose,
        title: 'Product linkage',
      }}>
      <Box>
        {(data?.length ? data : []).map((record, index) => (
          <Fragment key={record.id}>
            <ProductLinkageItem
              index={index}
              isLastItem={index === data.length - 1}
              data={{
                ...record,
                supplierName: get(record, 'productSupplierMaps[0].supplier.name'),
                image: get(record, 'productFiles[0].url'),
              }}
              usingViewProfile
              onClickViewProfile={handleClose}
            />
          </Fragment>
        ))}
      </Box>
    </Modal>
  );
};

export default ProductLinkageModal;
